import handleCsrfCookie from "../interceptors/csrf.js";
import handleAuthToken from "../interceptors/token.js";
import { useEchoAppConfig } from "../composables/useEchoAppConfig.js";
function useClientInterceptors(appConfig) {
  const [request, response] = [
    [
      handleCsrfCookie,
      handleAuthToken
    ],
    []
  ];
  if (appConfig.interceptors?.onRequest) {
    request.push(appConfig.interceptors.onRequest);
  }
  if (appConfig.interceptors?.onResponse) {
    response.push(appConfig.interceptors.onResponse);
  }
  return [request, response];
}
export function createFetchClient(app, authentication, logger) {
  const appConfig = useEchoAppConfig();
  const [
    requestInterceptors,
    responseInterceptors
  ] = useClientInterceptors(appConfig);
  const fetchOptions = {
    baseURL: authentication.baseUrl,
    credentials: "include",
    retry: false,
    async onRequest(context) {
      for (const interceptor of requestInterceptors) {
        await app.runWithContext(async () => {
          await interceptor(app, context, logger);
        });
      }
    },
    async onResponse(context) {
      for (const interceptor of responseInterceptors) {
        await app.runWithContext(async () => {
          await interceptor(app, context, logger);
        });
      }
    }
  };
  return $fetch.create(fetchOptions);
}
